export const cssHide = { style: { display: 'none' } };
